import { PAY_URL } from './constants';
import { PATH } from '../../constants/path';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';

export const payWithCheckoutFlow = async (token, userInfo, partnerId, orderId) => {
    try {
        const response = await fetch(PAY_URL, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            method: HTTP_METHOD_POST,
            body: JSON.stringify({ ...userInfo, partnerId, orderId })
        });

        if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`);
            return `${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error&orderId=${orderId}&code=${response.status}`;
        }

        const res = await response.json();
        return JSON.parse(res.payload.token);
    } catch (error) {
        console.error('error while trying to create a Flow payment session :', error);
        throw error;
    }
};



// WEBPACK FOOTER //
// ./src/services/checkout/utils.js